import { Box, Typography } from "@mui/material";
import { ProductContext } from "../provider.js";
import { SuspectName } from "../suspects/index.js";
import Grid from "@mui/material/Unstable_Grid2";
import Image from "next/image";
import React from "react";
export const CostumeSuggestions = ({ sx = {} }) => {
    const COLUMN_STYLES = { textAlign: "center", px: 4 };
    const { suspects } = React.useContext(ProductContext);
    const listRef = React.useRef(null);
    return (React.createElement(Grid, { columnSpacing: 0, component: "ul", container: true, ref: listRef, rowSpacing: { xs: 10, sm: 8, md: 10, lg: 12, xl: 14 }, sx: { listStyle: "none", padding: "0 !important", mt: 4, ...sx } }, suspects.map(({ age, costumeSuggestion, imageWithBorder, name }) => (React.createElement(Grid, { component: "li", key: `costume-suggestion-${name}`, xs: 12, sm: 6, lg: 4, xl: 3, sx: COLUMN_STYLES },
        React.createElement(Box, { sx: { transform: "scale(1.5)", mb: 2, px: 3 } },
            React.createElement(Image, { ...imageWithBorder, alt: `${name} (${age})`, placeholder: "empty", style: { width: "100%", height: "auto" } })),
        React.createElement(SuspectName, { age: age, name: name, sx: { mt: 0 } }),
        React.createElement(Typography, { variant: "body1", dangerouslySetInnerHTML: { __html: costumeSuggestion } }))))));
};
//# sourceMappingURL=costume-suggestions.js.map